export default __webpack_public_path__ + "static/media/button talkback-5.e8a8bf71.png";